import { render, staticRenderFns } from "./WhyITendtoPreferEquityRoundsOverNotes.vue?vue&type=template&id=2e9f2796"
import script from "./WhyITendtoPreferEquityRoundsOverNotes.vue?vue&type=script&lang=js"
export * from "./WhyITendtoPreferEquityRoundsOverNotes.vue?vue&type=script&lang=js"
import style0 from "./WhyITendtoPreferEquityRoundsOverNotes.vue?vue&type=style&index=0&id=2e9f2796&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports